import StatusBadge from './StatusBadge';
import { money } from '../lib/format';

// Shows the invoices + retainers linked to a job, with a small billing summary.
// Expects job.invoices [] and job.billing {} as returned by GET /api/jobs/:id.
export default function JobBilling({ job }) {
  if (!job) return null;
  const invoices = job.invoices || [];
  const b = job.billing || {};
  return (
    <div className="job-billing">
      <h3 className="form-section">Billing</h3>
      {invoices.length === 0 ? (
        <p className="hint">No invoices or retainers linked yet. Link one from an invoice’s “Link to job” field.</p>
      ) : (
        <>
          <table className="rep-table">
            <thead>
              <tr><th>Number</th><th>Type</th><th>Status</th><th className="num">Total</th><th className="num">Balance</th></tr>
            </thead>
            <tbody>
              {invoices.map((i) => (
                <tr key={i.id}>
                  <td>{i.invoice_number}</td>
                  <td>{i.kind === 'retainer' ? 'Retainer' : 'Invoice'}</td>
                  <td><StatusBadge status={i.status} /></td>
                  <td className="num">{money(i.total)}</td>
                  <td className="num">{money(i.balance)}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="job-billing__sum">
            <div><span>Invoiced</span><strong>{money(b.invoiced)}</strong></div>
            <div><span>Paid</span><strong>{money(b.paid)}</strong></div>
            <div><span>Outstanding</span><strong>{money(b.outstanding)}</strong></div>
            {Number(b.retainer_total) > 0 && (
              <div><span>Retainer collected</span><strong>{money(b.retainer_collected)}</strong></div>
            )}
          </div>
        </>
      )}
    </div>
  );
}
